import React from "react";
import { useTranslation } from "react-i18next";
import "./index.less";

type Props = {
  open: boolean;
  handleToggle: () => void;
  handleConfirm: () => void;
  confBtnMsg: string;
  title?: string;
  subTitle?: string;
};

export const LandscapeConfirmationModal = (props: Props) => {
  const { t } = useTranslation();
  const { open, handleConfirm, handleToggle, confBtnMsg, title, subTitle } = props;

  if (!open) return null;

  const handleOverlayClick = () => {
    if (handleToggle) {
      handleToggle();
    }
  };

  const handleModalClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.stopPropagation();
  };

  return (
    <div className="landscape-confirmation-overlay" onClick={handleOverlayClick}>
      <div className="landscape-confirmation-content" onClick={handleModalClick}>
        <div className="landscape-confirmation-container">
          <div className="landscape-confirmation-title">{title}</div>
          {subTitle && <div className="landscape-confirmation-desc">{subTitle}</div>}
          <div className="landscape-confirmation-buttons">
            <button className="landscape-confirm-button" onClick={handleConfirm}>
              {confBtnMsg}
            </button>
            <button className="landscape-cancel-button" onClick={handleToggle}>
              {t("cancel")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
